import protoRoot from "../proto-root";
import BatteryStatus from "../private/BatteryStatus";
import CameraAndFlashlightState from "../private/CameraAndFlashlightState";
import CameraAlarmStatus from "../private/CameraAlarmStatus";
import CameraRecordingStatus from "../private/CameraRecordingStatus";

const name = "syncMonitoringRPCResponse";

function create({ batteryStatus, cameraState, alarmStatus, videoRecordingStatus }: SyncMonitoringResponse) {
  const SyncMonitoring = protoRoot.lookupType("comm.SyncMonitoringRPCResponse");
  const request = SyncMonitoring.create({
    batteryStatus: BatteryStatus.create(batteryStatus),
    cameraState: CameraAndFlashlightState.create({ cameraId: cameraState.cameraId || "" }),
    alarmStatus: alarmStatus ? CameraAlarmStatus.create(alarmStatus) : undefined,
    videoRecordingStatus: videoRecordingStatus ? CameraRecordingStatus.create(videoRecordingStatus) : undefined
  });

  return { payload: request, name };
}

const syncMonitoringRPCResponse = { create, name };
export default syncMonitoringRPCResponse;
